module.exports = __webpack_public_path__ + "afcff2a0e1a06eae10e1302eeca1cb39.fbx";